'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ShareArticle = require('./ShareArticle');

var _ShareArticle2 = _interopRequireDefault(_ShareArticle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ShareArticle2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ShareArticle/index.js
// module id = 651
// module chunks = 11